import RefillBallBinFlow from "./RefillBallBinFlow";

export default function ManualRefillBallBinFlow(): React.JSX.Element | null {
    return RefillBallBinFlow({ manual: true });
}
